import _ from 'lodash';
import { i18n } from './i18n';
import pluralize from 'pluralize';
import { TAG_TYPE } from '@/constants';
import { modelData, getLabel } from '@/custom_models_extend';

const linkTo = ({ item, v }) => {
  return { name: `${pluralize(_.snakeCase(v.extra.model_name))}.show`, params: { id: item.id } }
}

const components = {
  id: function() {
    return {
      width: 80
    }
  },
  type: function({ v }) {
    return {
      renderCell: (h, { props: { value } }) => {
        return <span>{i18n.t(`${modelData[v.model_name]['element']}.types.${value}`)}</span>;
      },
    }
  },
  attached: function({ v }) {
    const width = _.get(v, 'extra.type') === 'audio' ? 200 : 120

    return {
      width: width,
      renderCell: 'storageAttachment',
    }
  },
  belongsTo: function({ v }) {
    return {
      renderCell: (h, { props: { value } }) => {
        if (value) {
          return <bean-link keepNode to={linkTo({ item: value, v })}>{getLabel({ item: value, v })}</bean-link>
        } else {
          return <span>/</span>
        }
      },
    }
  },
  hasMany: function({ v }) {
    return {
      renderCell: (h, { props: { value } }) => {
        if (value.length) {
          return _.map(value, (object) => <div><bean-link keepNode to={linkTo({ item: object, v })}>{getLabel({ item: object, v })}</bean-link></div>)
        } else {
          return <span>/</span>
        }
      }
    }
  },
  enum: function({ k, v }) {
    return {
      renderCell: (h, { props: { scope: { row } } }) => {
        if (!row[k]) {
          return <span>/</span>
        }
        return <el-tag type={TAG_TYPE[row[k]]}>{i18n.t(`${modelData[v.model_name]['element']}.${pluralize(_.camelCase(k))}.${row[k]}`)}</el-tag>;
      },
    }
  },
  string: function() {
    return {}
  },
  integer: function () {
    return {}
  },
  decimal: function () {
    return {}
  },
  float: function () {
    return {}
  },
  text: function () {
    return {
      renderCell: (h, { props: { value } }) => {
        if (!value) {
          return '<span>/</span>'
        }
        return <span style="white-space: pre-wrap; word-break: break-all">{value}</span>
      },
    }
  },
  boolean: function () {
    return {
      renderCell: 'bool'
    }
  },
  date: function () {
    return {
      renderCell: 'date'
    }
  },
  time: function () {
    return {
      renderCell: 'time'
    }
  },
  datetime: function () {
    return {
      minWidth: 120,
      renderCell: 'time',
    }
  },
  tag: function() {
    return {
      minWidth: 150,
      renderCell: (h, { props: { value } }) => {
        if (value.length) {
          return _.map(value, (object) => <el-tag style={{ 'margin-right': '3px' }}>{object}</el-tag>)
        } else {
          return <span>/</span>
        }
      },
    }
  }
}

export default function(columns) {
  let hash = {}

  _.forEach(columns, (v, k) => {
    if (v.column_type && components[_.camelCase(v.column_type)]) {
      hash[k] = _.merge({
        prop: v.prop || k,
        label: i18n.t(`${modelData[v.model_name]['element']}.${_.camelCase(k)}`),
      }, components[_.camelCase(v.column_type)]({ k, v }))
    } else {
      components.string()
    }
  })

  return hash
}
